module.exports = __webpack_public_path__ + "static/media/signage-industrial-img6.971c0a2a.jpg";